<template>
  <div class="service-cycle-alarm">
    <p>
      {{ $t('messages.alarms.serviceCycleAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    />

    <hr>

    <div class="g-alarm-handler__row">
      <!-- <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>{{ $t('messages.alarms.serviceCycleAlarm.suggestion') }}</p> -->

      <slot v-if="store.getData('user.access.programEdit')">
        <p>
          {{ $t('messages.alarms.serviceCycleAlarm.label1') }}
        </p>

        <div class="g-alarm-handler__row g-text g-text--center">
          <button
            type="button"
            class="g-btn g-btn--rounded g-btn--blue"
            @click.stop="$router.push('/programs')"
          >
            {{ $tc('messages.sharedTexts.programs.program', 0) }} <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </button>
        </div>
      </slot>
      <p
        v-else
        class="g-alarm-handler__highlight g-alarm-handler__highlight--yellow"
      >
        <strong>{{ $t('messages.alarms.attention') }}</strong>: {{ $t('messages.alarms.serviceCycleAlarm.attention') }}
      </p>
    </div>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceCycleAlarm',
  mixins: [ServiceAlarm],
  data() {
    return {
    }
  }
}
</script>
